import { ContainerStatus } from '../types/container.types';
import { ShipmentStatus } from '../types';
import { PALLET_CONTAINER_TYPE_ID } from './boxTypeFilters';
export var AUTO_ELIGIBLE_STATUSES = [
    ShipmentStatus.Input,
    ShipmentStatus.Scheduled,
    ShipmentStatus.Picked
];
/** Every item on the shipment packed  */
export var areAllItemsPacked = function (itemSourceList) {
    if (!(itemSourceList === null || itemSourceList === void 0 ? void 0 : itemSourceList.length))
        return false;
    var totalQty = 0;
    var packedQty = 0;
    itemSourceList.forEach(function (item) {
        var _a, _b, _c;
        totalQty += (_a = item === null || item === void 0 ? void 0 : item.quantity) !== null && _a !== void 0 ? _a : 0;
        packedQty += ((_b = item === null || item === void 0 ? void 0 : item.quantity) !== null && _b !== void 0 ? _b : 0) - ((_c = item === null || item === void 0 ? void 0 : item.quantityNotHandled) !== null && _c !== void 0 ? _c : 0);
    });
    return totalQty > 0 && packedQty === totalQty;
};
/**
 * Resolves the auto-complete flow would close, or null when the shipment is not eligible.
 * Rules:
 *  - Exactly one open root carton with no package yet
 *  - Legacy: a single package that still has no box type / weight
 */
export var resolveAutoCloseTarget = function (containers, packages) {
    var containerList = containers !== null && containers !== void 0 ? containers : [];
    var packageList = packages !== null && packages !== void 0 ? packages : [];
    if (containerList.length === 1) {
        var container = containerList[0];
        if (!container.isRoot)
            return null;
        if (container.statusId !== ContainerStatus.Open)
            return null;
        if (container.containerTypeEnumId === PALLET_CONTAINER_TYPE_ID)
            return null;
        if (packageList.length !== 0)
            return null;
        return { kind: 'container', containerId: container.containerId, containerSeqNum: container.containerSeqNum };
    }
    if (containerList.length === 0 && packageList.length === 1) {
        var pkg = packageList[0];
        if (pkg.shipmentBoxTypeId && pkg.weight)
            return null;
        return { kind: 'package', seqId: pkg.shipmentPackageSeqId };
    }
    return null;
};
